<template>
  <div>
    <div style="margin-top: 10px;">
      <el-input v-model="keywords" placeholder="通过用户名搜索用户" prefix-icon="el-icon-search"
                style="width: 300px;margin-right: 10px;" @keydown.enter.native="doSearch"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="doSearch()">搜索</el-button>
    </div>
    <div class="admin-container">
      <el-card class="admin-card" v-for="(admin,index) in admins" :key="index">
        <div slot="header" class="clearfix">
          <span style="font-size: 20px;">{{ admin.username }}</span>
          <el-button style="float: right; padding: 3px 0;color: #a43629" type="text" icon="el-icon-delete"
                     @click="deleteAdmin(admin)"></el-button>
        </div>
        <div class="userInfo-container">
          <div>昵称：{{ admin.nickname }}</div>
          <div>学校：{{ admin.schoolName }}</div>
          <div>
            用户角色：
            <el-tag style="margin-right:4px;" type="success" v-for="(role,indexJ) in admin.roles" :key="indexJ">
              {{ role.nameZh }}
            </el-tag>
            <el-popover
                placement="right"
                title="角色列表"
                width="200"
                @show="showRoles(admin)"
                @hide="hideRoles(admin)"
                trigger="click">
              <el-select v-model="selectRoles" multiple placeholder="请选择">
                <el-option
                    v-for="(r,index) in allRoles"
                    :key="index"
                    :label="r.nameZh"
                    :value="r.id">
                </el-option>
              </el-select>
              <el-button type="text" slot="reference" icon="el-icon-more"></el-button>
            </el-popover>
          </div>
          <div>
            用户状态：
            <el-switch
                @change="enabledChange(admin)"
                v-model="admin.enabled"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="启用"
                inactive-text="禁用">
            </el-switch>
          </div>
        </div>
      </el-card>

    </div>
  </div>
</template>

<script>
export default {
  name: 'SysAdmin',
  data() {
    return {
      admins: [],
      keywords: '',
      allRoles: [],
      selectRoles: []
    }
  },
  // mounted () {
  //   this.initAdmins()
  // },
  methods: {
    hideRoles(admin) {
      const roles = []
      Object.assign(roles, admin.roles)
      let flag = false
      if (roles.length !== this.selectRoles.length) {
        flag = true
      } else {
        for (let i = 0; i < roles.length; i++) {
          const role = roles[i]
          for (let j = 0; j < this.selectRoles.length; j++) {
            const sr = this.selectRoles[i]
            if (role.id === sr) {
              role.splice(i, 1)
              i--
              break
            }
          }
        }
        if (roles.length !== 0) {
          flag = true
        }
      }

      if (flag) {
        let url = '/system/basic/userRole/role?userId=' + admin.id
        this.selectRoles.forEach(sr => {
          url += '&rids=' + sr
        })
        this.putRequest(url).then(resp => {
          if (resp) {
            this.initAdmins()
          }
        })
      }
    },
    showRoles(admin) {
      this.initAllRoles()
      const roles = admin.roles
      this.selectRoles = []
      roles.forEach(r => {
        this.selectRoles.push(r.id)
      })
    },
    initAllRoles() {
      this.getRequest('/system/basic/role').then(resp => {
        if (resp) {
          this.allRoles = resp
        }
      })
    },
    doSearch() {
      this.initAdmins()
    },
    enabledChange(admin) {
      this.putRequest('/userInfo/web/edit', admin).then(resp => {
        if (resp) {
          this.initAdmins()
        }
      })
    },
    deleteAdmin(admin) {
      this.$confirm('此操作将永久删除【' + admin.username + '】操作员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/user/' + admin.id).then(resp => {
          if (resp) {
            this.initAdmins()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    initAdmins() {
      this.getRequest('/system/basic/userRole/?keywords=' + this.keywords).then(resp => {
        if (resp) {
          this.admins = resp
        }
      })
    }
  }
}
</script>

<style>
.admin-container {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  flex-wrap: wrap;
}

.admin-card {
  width: 350px;
  margin-bottom: 20px;
}

.userInfo-container {
  color: #303133;
}
</style>
